// @flow
import { SECTIONS } from 'Client/cms/toolkit/constants';
import { SectionsLine } from 'Components/lines/sections-line/SectionsLine.jsx';
import { sectionsResolver } from './sections.resolver';

export const sectionsDescriptor = {
  name: SECTIONS,
  component: SectionsLine,
  resolve: sectionsResolver.resolve,
};
